import React from 'react'
import { InputField } from 'components/molecules'
import { Card } from 'reactstrap'
import { DESCRIPTION } from 'domains/cms-blog-post/constants'

const BlogPostMetadataFields = () => (
  <>
    <h2> Meta Data </h2>
    <p>{ DESCRIPTION.METADATA }</p>

    <Card body>
      <InputField
        type='text'
        name={ 'meta_data.title' }
        label='Meta Data Title'
        required={ false }
      />
      <InputField
        type='textarea'
        rows='5'
        name={ 'meta_data.keyword' }
        label='Meta Data Keyword'
        required={ false }
      />
      <InputField
        type='textarea'
        rows='5'
        name={ 'meta_data.description' }
        label='Meta Data Description'
        required={ false }
      />
    </Card>
  </>
)

export default BlogPostMetadataFields
